import React, { useState } from "react";
import Filter from "./Filter";
import Table from "./Table";
import './User.css'
import Add_User from "./Add_User";
import Edit_User from "./Edit_User";
// import Add_Role from "./Add_Role";
// import Edit_Role from "./Edit_Role";

const User = () => {
  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);

  return (
    <section className="User Roles">
     
      <div className="filter_div">
        <Filter setAdd={setAdd}/>
      </div>

      <div className="sample_table_div">
        <Table setEdit={setEdit}/>
      </div>

      <Add_User show={add} setShow={setAdd} handleClose={() => {setAdd(false)}} />
      <Edit_User show={edit} setShow={setEdit} handleClose={() => {setEdit(false)}} />
   
    </section>
  );
};

export default User;
